import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

// Modal de bloqueio (antes script inline). Abre o .modal (singleton), injeta o
// form (de um <template>), preenche os campos ocultos com os valores do gatilho
// e trata o submit via fetch + swal + Turbo. Datepicker via Stimulus
// (data-controller="datepicker").
export default class extends Controller {
  static targets = ["template"]
  static values = {
    alvoType: String,
    alvoId: String,
    origemType: String,
    origemId: String,
    url: String
  }

  open(event) {
    event.preventDefault()

    const alvoType = this.alvoTypeValue
    const alvoId = this.alvoIdValue
    const origemType = this.origemTypeValue
    const origemId = this.origemIdValue
    const urlPost = this.urlValue

    document.querySelector(".modal").classList.add("is-active")
    const modalContent = document.querySelector(".modal-content")
    modalContent.innerHTML = this.templateTarget.innerHTML
    modalContent.style.width = "40%"

    document.querySelector("input[name='alvo_type']").value = alvoType
    document.querySelector("input[name='alvo_id']").value = alvoId
    document.querySelector("input[name='origem_type']").value = origemType
    document.querySelector("input[name='origem_id']").value = origemId
    document.querySelector("input[name='url']").value = urlPost

    // Período: habilita as datas apenas quando "temporário"
    const datas = document.querySelectorAll("input[name='data_inicio'], input[name='data_fim']")
    datas.forEach((el) => { el.disabled = true })
    document.querySelectorAll("input[name='periodo_bloqueio']").forEach((radio) => {
      radio.addEventListener("click", (e) => {
        datas.forEach((el) => { el.disabled = (e.target.value === "sempre") })
      })
    })

    document.querySelector("#efetuarBloqueio").addEventListener("click", (e) => {
      e.preventDefault()
      const dataInicio = document.querySelector("input[name='data_inicio']").value
      const dataFim = document.querySelector("input[name='data_fim']").value
      const motivo = document.querySelector("input[name='motivo']").value

      const montaParametros = {}
      if (origemType) montaParametros.origem_type = origemType
      if (origemId) montaParametros.origem_id = origemId
      if (alvoType) montaParametros.alvo_type = alvoType
      if (alvoId) montaParametros.alvo_id = alvoId
      if (dataInicio) montaParametros.data_inicio = dataInicio
      if (dataFim) montaParametros.data_fim = dataFim
      if (motivo) montaParametros.motivo = motivo

      const token = document.querySelector('meta[name="csrf-token"]')?.content
      fetch(urlPost, {
        method: "POST",
        headers: {
          "X-CSRF-Token": token,
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams(montaParametros)
      })
        .then((response) => {
          if (!response.ok) throw new Error("HTTP " + response.status)
          document.querySelector(".modal").classList.remove("is-active")
          setTimeout(function () {
            Swal.fire({ text: "Bloqueio efetuado com sucesso.", icon: "success", confirmButtonText: "OK" })
              .then(function () { Turbo.visit(location.toString()) })
          }, 300)
        })
        .catch((error) => { console.log(error) })
    })

    document.querySelector("#fecharTelaBloqueio").addEventListener("click", () => {
      document.querySelector(".modal").classList.remove("is-active")
    })
  }
}
